// Section 24.15: the sim throws typed errors and never swallows them.

export type SimErrorCode =
  | 'invalid_decision'
  | 'invariant'
  | 'bad_status'
  | 'unknown_id'
  | 'registry'
  | 'migration'
  | 'schema';

export interface SimErrorContext {
  turn?: number;
  phase?: string;
  ids?: string[];
  [key: string]: unknown;
}

export class SimError extends Error {
  readonly code: SimErrorCode;
  readonly context: SimErrorContext;

  constructor(code: SimErrorCode, message: string, context: SimErrorContext = {}) {
    super(`[${code}] ${message}`);
    this.name = 'SimError';
    this.code = code;
    this.context = context;
  }
}

export function isSimError(error: unknown): error is SimError {
  return error instanceof SimError;
}

/** Exhaustiveness helper for `switch` over unions (24.16). */
export function assertNever(value: never, what = 'value'): never {
  throw new SimError('invariant', `unexpected ${what}: ${JSON.stringify(value)}`);
}
